import { useMemo } from 'react';
import { Col, Row, Typography } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';
import Gdprlogs from 'libs/api/admin/gdprlogs';
import moment from 'moment';
import 'moment/locale/it';
import { useApi } from 'hooks/useApi';

const api = new Gdprlogs();

const useLogs = (isMainPage = true) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const {
    data,
    loading,
    singleItem: singleData,
    onChangeTableFilter,
    handleDownloadExcel,
  } = useApi({
    resourceKey: 'gdprlogs',
    singleResourceKey: 'gdprlog',
    api,
    isMainPage,
  });

  const filters = useMemo(() => {
    return [
      {
        title: t('Email'),
        type: 'input',
        name: 'by_email',
      },
      {
        title: t('User ID'),
        type: 'input',
        name: 'by_user_id',
      },
      {
        title: t('IP'),
        type: 'input',
        name: 'by_ip',
      },
      {
        title: t('Text'),
        type: 'input',
        name: 'by_text',
      },
      {
        title: t('Date'),
        type: 'range',
        name: 'range',
        keys: ['by_date_from', 'by_date_to'],
      },
      {
        title: t('Type'),
        type: 'select',
        name: 'by_type',
        values: [
          { value: 'GET', title: 'GET' },
          { value: 'DELETE', title: 'DELETE' },
          { value: 'POST', title: 'POST' },
        ],
      },
    ];
  }, [t]);

  const columns = useMemo(() => {
    return [
      {
        title: t('Utente'),
        dataIndex: 'users.surname',
        // width: 100,
        sorter: () => {},
        render: (data, row) => {
          return (
            <Typography>
              {row.user.surname_name}
              <br />
              {row.remote_ip}
            </Typography>
          );
        },
      },
      {
        title: t('Email'),
        dataIndex: 'user',
        // width: 100,
        sorter: () => {},
        render: (data) => {
          return data.email;
        },
      },
      {
        title: t('Created'),
        dataIndex: 'created_at',
        // width: 100,
        sorter: () => {},
        render: (data) => {
          return moment(data).format('DD-MMMM-YYYY HH:MM');
        },
      },
      {
        title: t('Tipo'),
        dataIndex: 'request_type',
        width: 100,
        sorter: () => {},
      },
      {
        title: t('Request url'),
        dataIndex: 'request_url',
        // width: 100,
        sorter: () => {},
      },
      {
        title: '',
        dataIndex: 'id',
        align: 'right',
        width: 100,
        render: (data, row) => (
          <Row gutter={16} justify={'end'}>
            <Col>
              <Link to={`${pathname}/${row.id}`}>
                <Button type={'primary'}>{t('APRI')}</Button>
              </Link>
            </Col>
          </Row>
        ),
      },
    ];
  }, [t, pathname]);

  return {
    columns,
    data,
    singleData,
    loading,
    onChangeTableFilter,
    filters,
    handleDownloadExcel,
  };
};

export default useLogs;
